import { yupResolver } from '@hookform/resolvers/yup';
import { TournamentMatchResultsFormFields } from 'modules/bracket/interfaces';
import { useCallback, useMemo } from 'react';
import { tournamentMatchResultsValidationSchema } from './tournament-match-results-validation-schema';
import { useForm, UseFormReturn } from 'react-hook-form';

interface UseTournamentMatchResultsFormHook {
  form: UseFormReturn<TournamentMatchResultsFormFields>;
  resetToDefault: () => void;
}

export const useTournamentMatchResultsForm = (): UseTournamentMatchResultsFormHook => {
  const defaultTournamentTeam = useMemo(
    () => ({
      results: [],
    }),
    []
  );

  const formResolver = yupResolver(tournamentMatchResultsValidationSchema());
  const form = useForm<TournamentMatchResultsFormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: defaultTournamentTeam,
  });

  const resetToDefault = useCallback(() => {
    form.reset(defaultTournamentTeam);
  }, [defaultTournamentTeam, form]);

  return {
    form,
    resetToDefault,
  };
};
